import { render, staticRenderFns } from "./ModalAccessoryOrderStatistics.vue?vue&type=template&id=2591ea92&scoped=true"
import script from "./ModalAccessoryOrderStatistics.vue?vue&type=script&lang=js"
export * from "./ModalAccessoryOrderStatistics.vue?vue&type=script&lang=js"
import style0 from "./ModalAccessoryOrderStatistics.vue?vue&type=style&index=0&id=2591ea92&prod&lang=scss"
import style1 from "./ModalAccessoryOrderStatistics.vue?vue&type=style&index=1&id=2591ea92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2591ea92",
  null
  
)

export default component.exports